import type {PluralFormsModel} from '@/types/content/pluralForms';

/**
 * Resolves a plural form string from AEM content based on count and locale.
 * Uses the browser's built-in Intl.PluralRules for locale-aware plural resolution.
 * Templates use `{0}` as placeholder for the number.
 *
 * Example:
 *   formatPlural(3, { one: "{0} action remaining", other: "{0} actions remaining" }, "en")
 *   → "3 actions remaining"
 */
export const formatPlural = (
    count: number,
    forms: PluralFormsModel | undefined | null,
    locale: string
): string | undefined => {
    if (!forms) return undefined;

    const rule = new Intl.PluralRules(locale).select(count);
    const template = forms[rule as keyof PluralFormsModel] ?? forms.other;

    if (!template) return undefined;

    return template.replace(/\{0\}/g, count.toString());
};
